<script>
  import { Circle } from "svelte-loading-spinners";
  import { browser } from "../stores";
  import DynamicSecsAndOrgs from "../helpers/DynamicSecsAndOrgs.svelte";
  import FeaturedReports from "../components/FeaturedReports/FeaturedReports.svelte";
  import Header from "../components/Common/Header.svelte";
  import SearchForm from "../components/Reports/SearchForm.svelte";
  import SearchForm__IE from "../components/Reports/SearchForm__IE.svelte";
  import SectorPreviewGrid from "../components/Sectors/SectorPreviewGrid.svelte";

  // Get the "Open Georgia" CTA
  let openGA = document.querySelector(".open-georgia");
  if (openGA) {
    openGA = openGA.cloneNode(true);
    openGA.style.display = "block";
    openGA = openGA.outerHTML;
  }
</script>

<Header>
  <h1>Reports</h1>
  <p>
    Explore our published documents provided to government decision-makers and
    the public.
  </p>
</Header>
<DynamicSecsAndOrgs let:sectors let:organizations let:loading>
  {#if browser.name === "ie"}
    <SearchForm__IE {sectors} {organizations} {loading} />
  {:else}
    <SearchForm {sectors} {organizations} {loading} useHttp={true} />
  {/if}
  <FeaturedReports />
  <div class="browse-sectors">
    <div class="container">
      <h2 class="browse-sectors-heading">Browse Reports by Sector</h2>
      {#if loading}
        <div class="loader-wrap">
          <Circle size="100" color="#4a4a4a" unit="px" />
        </div>
      {:else}
        <SectorPreviewGrid {sectors} mode="browse" />
      {/if}
    </div>
  </div>
</DynamicSecsAndOrgs>
{@html openGA}

<style>
  .browse-sectors {
    padding-top: 80px;
    border-bottom: 2px solid #ebe9e9;
  }

  .loader-wrap {
    padding: 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 580px) {
    .browse-sectors {
      padding-top: 40px;
    }
  }
</style>
